import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage: Storage = localStorage;

  public readonly TOKEN_KEY: string = `${STORAGE_KEY}-TOKEN`;
  public readonly USER_KEY: string = `${STORAGE_KEY}-USER`;
  public readonly GROUP_KEY: string = `${STORAGE_KEY}-GROUP`;

  public get token(): string {
    return this.storage.getItem(this.TOKEN_KEY) || '';
  }

  public set token(value: string | null | undefined) {
    if (value === '' || value === undefined || value === null) {
      this.storage.removeItem(this.TOKEN_KEY);
    } else {
      this.storage.setItem(this.TOKEN_KEY, value);
    }
  }

  public get group(): any {
    return this.storage.getItem(this.GROUP_KEY);
  }

  public set group(value: any | null | undefined) {
    if (value === '' || value === undefined || value === null) {
      this.storage.removeItem(this.GROUP_KEY);
    } else {
      this.storage.setItem(this.GROUP_KEY, value);
    }
  }

  public get user(): any {
    return this.storage.getItem(this.USER_KEY);
  }

  public set user(value: any | null | undefined) {
    if (value === '' || value === undefined || value === null) {
      this.storage.removeItem(this.USER_KEY);
    } else {
      this.storage.setItem(this.USER_KEY, value);
    }
  }

  constructor() {}
}

export const STORAGE_KEY: string = 'EBS-STORAGE';
